export enum ResourceType {
  VIDEO = 'video',
  LIVE_CLASS = 'liveClass',
  QUIZZ = 'quiz',
}
